export default __webpack_public_path__ + "static/media/Desenvolvimento-Web-EN.e2f7f078.jpg";